import { render, staticRenderFns } from "./QueueTable.vue?vue&type=template&id=5e2f5de0"
import script from "./QueueTable.vue?vue&type=script&lang=js"
export * from "./QueueTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports